module.exports = __webpack_public_path__ + "img/14-detail.68665482.webp";